@if (blogPost$ | async; as blogPost) {
  <div class="rmaContainer">
    <h1 class="title">{{ blogPost.title }}</h1>
    <div class="imageWrapper">
      <img class="image" [srcset]="srcSet$ | async" sizes="(min-width: 1200px) 1200px, 100vw" alt="" aria-hidden="true" />
    </div>
    <div class="socialButtonsWrapper">
      <rma-blog-social-share-button class="socialButtons" [slug]="blogPost.slug" />
    </div>
    <rma-blog-post-content [safeContent]="blogPost.content | safe: 'html'" />
  </div>
} @else {
  <div class="content">
    <rma-blog-post-skeleton layout="page" />
  </div>
}
